export default __webpack_public_path__ + "static/insurance-2dc77fd50496599d73bd4e845a4520db.mp4";